import { EmailTemplate, EmailTemplateToSend } from "../../models/templates/email.template";
import BaseService from "../_base.service";
import API from "../../api";

const endpoint = "emails/templates";

export interface ProcessEmailTemplate {
  html: string;
  data: {
    companyName?: string;
    quoteReference?: string;
    customerFullName?: string;
    userFullname?: string
  }
}
export interface ProcessEmailTemplateTag extends ProcessEmailTemplate {
  tag: string;
}

export const EmailTemplateService = {
  ...BaseService<EmailTemplate>({ endpoint }),
  async send (email: EmailTemplateToSend) {
    return await API.put('notification/email/template/send', email);
  },
  async processEmailTemplateHtml (payload: ProcessEmailTemplate) {
    return await API.put('notification/email/template/replace-html-tags', payload);
  },
  async defaultTemplate(templateId: number, template: EmailTemplate) {
    return await API.put(`${endpoint}/default/${templateId}`, template);
  }
};
